import React from 'react'
import { Pagination } from '@mui/material'

const PaginationElement = ({ count, handleChange, page }) => {
  return <Pagination page={parseInt(page || 1)} count={count} onChange={handleChange} />
}

export default PaginationElement
